import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Carousel from './Carousel';
import Item from './Item';
import { CircularProgress } from '@material-ui/core';
import { fetchEvents } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  noItems: {
    padding: 50,
    textAlign: 'center'
  }
});

class PastEvents extends Component {
  state = {
    open: false,
    selected: 0,
    events: [],
    isLoading: false
  };

  componentDidMount() {
    this.loadEvents();
  }

  loadEvents = async () => {
    this.setState({ isLoading: true });

    const allEvents = await fetchEvents();

    const pastEvents = allEvents.filter(event => {
      if (!event.eventDate) return true;

      const eventDate = new Date(event.eventDate);
      const now = new Date();

      return eventDate < now;
    });

    this.setState({ events: pastEvents, isLoading: false });
  };

  expand = id => {
    const index = this.state.events.findIndex(event => event._id === id);
    this.setState({ selected: index, open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = selected => {
    this.setState({ selected });
  };

  render() {
    const { classes } = this.props;
    const { open, selected, events, isLoading } = this.state;

    if (isLoading) return <CircularProgress />;

    return (
      <div className={classes.root}>
        {events.length < 1 ? (
          <Grid item xs={12}>
            <div align="center" className={classes.noItems}>
            </div>
          </Grid>
        ) : (
          <Grid container spacing={2} direction="row" alignItems="flex-start">
            {events.map(event => {
              console.log(event, 'past event')
              return <Item
              key={event._id}
              section={event}
              width={4}
              expendable
              type="photo"
              onExpand={this.expand}
            />
            })}
          </Grid>
        )}

        {!!events.length && (
          <Carousel
            items={events}
            open={open}
            selected={selected}
            onClose={this.handleClose}
            onChange={this.handleChange}
          />
        )}
      </div>
    );
  }
}

PastEvents.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PastEvents);